











































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';
import HomeHeader from '@/components/home/HomeHeader.vue';
import HomeHeaderBottom from '@/components/home/HomeHeaderBottom.vue';
import ModalRegister from '@/components/auth/ModalRegister.vue';
import ModalLogin from '@/components/auth/ModalLogin.vue';
import ModalFindPassword from '@/components/auth/ModalFindPassword.vue';
import HomeMainSection from '@/components/home/HomeMainSection.vue';
import HomeCustomerSection from '@/components/home/HomeCustomerSection.vue';
import HomeQuantitySection from '@/components/home/HomeQuantitySection.vue';
import HomePurchaseSection from '@/components/home/HomePurchaseSection.vue';
import HomeStockSection from '@/components/home/HomeStockSection.vue';
import HomeInfoSection from '@/components/home/HomeInfoSection.vue';
import HomeFunctionSection from '@/components/home/HomeFunctionSection.vue';
import HomeReviewSection from '@/components/home/HomeReviewSection.vue';
import HomePriceSection from '@/components/home/HomePriceSection.vue';
import HomeSloganSection from '@/components/home/HomeSloganSection.vue';
import HomeFooterSection from '@/components/home/HomeFooterSection.vue';

const namespace: string = 'auth';

@Component({
  components: {
    HomeHeaderBottom,
    HomeMainSection,
    HomeCustomerSection,
    HomeQuantitySection,
    HomePurchaseSection,
    HomeStockSection,
    HomeInfoSection,
    HomeFunctionSection,
    HomeReviewSection,
    HomePriceSection,
    HomeSloganSection,
    HomeFooterSection,
    ModalRegister,
    ModalLogin,
    ModalFindPassword,
    HomeHeader,
  },
})
export default class Home extends Vue {
  @Action('logout', { namespace }) c_logout!: any;

  @Getter('getterIsRegister', { namespace }) c_getterIsRegister!: any;

  public isModalLogin: boolean = false;
  public isModalRegister: boolean = false;
  public isModalFindPassword: boolean = false;
  public isSticky: boolean = false;
  public activeIndex: string = '1';

  created() {
    if (this.c_getterIsRegister.hasOwnProperty('email'))
      this.$router.replace({ path: '/register' });
  }

  @Watch('$route', { immediate: true })
  onRouteWatch(c: any, p: any) {
    this.isModalLogin = c.meta && c.meta.isModalLogin;
    this.isModalRegister = c.meta && c.meta.isModalRegister;
    this.isModalFindPassword = c.meta && c.meta.isModalFindPassword;
  }

  detectWindowScrollY(): void {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    this.isSticky = scrollTop > 0;
  }

  onBackToHome() {
    this.$router.push({ path: '/' });
  }

  mounted() {
    window.addEventListener('scroll', this.detectWindowScrollY);
  }

  beforeDestroy() {
    window.removeEventListener('scroll', this.detectWindowScrollY);
  }

  handleSelect(key: any, keyPath: any) {
    console.log(key, keyPath);
  }
}
